export type TListingOffersByIdsRequestId = number;

let listingOffersByIdsRequestGeneration = 0;

export const startListingOffersByIdsRequest = (): TListingOffersByIdsRequestId => {
  listingOffersByIdsRequestGeneration += 1;

  return listingOffersByIdsRequestGeneration;
};

export const invalidateListingOffersByIdsRequests = () => {
  listingOffersByIdsRequestGeneration += 1;
};

export const isActualListingOffersByIdsRequest = (requestId: TListingOffersByIdsRequestId): boolean => {
  return requestId === listingOffersByIdsRequestGeneration;
};
